(function () {
  'use strict';

  const GLOBAL_KEY = 'GBRdwProductPageV713NL1631';
  const BLUE_FLAG_KEY = 'gbBlueRecommended';
  const BLUE_ELIGIBLE_PLATES_KEY = 'gbBlueEligiblePlates';

  const TRANSLATIONS = {
    nl: {
      title: 'Controleer uw Nederlandse kenteken',
      intro: 'Wij halen de voertuiggegevens automatisch op bij RDW. Een kentekenbewijs uploaden is niet nodig.',
      plateLabel: 'Kenteken', placeholder: 'Bijv. AB-12-CD', lookup: 'Kenteken controleren', loading: 'RDW wordt gecontroleerd…',
      hint: 'Eén kenteken per bestelling. Voeg meerdere voertuigen één voor één toe.',
      confirm: 'Ja, dit is mijn voertuig en het kenteken is correct.',
      eligibleHeading: 'Dit voertuig is geschikt voor de groene milieusticker.',
      eligibleText: 'Bevestig het voertuig. Daarna kunt u de sticker aan de winkelwagen toevoegen.',
      manualHeading: 'Dit voertuig moet handmatig worden gecontroleerd.',
      manualText: 'Met de beschikbare RDW-gegevens kan geen veilige automatische beslissing worden genomen. Gebruik het artikel met kentekenbewijs-upload.',
      noneHeading: 'Voor dit voertuig kan geen groene milieusticker worden afgegeven.',
      noneText: 'Volgens de beschikbare RDW-gegevens voldoet het voertuig niet aan de voorwaarden.',
      uploadButton: 'Bestellen met kentekenbewijs-upload', blueText: 'Voor dit voertuig wordt ook de blauwe E-sticker aanbevolen.', blueLink: 'Bekijk de blauwe E-sticker',
      vehicle: 'Voertuig', vehicleType: 'Voertuigsoort', fuel: 'Brandstof', firstReg: 'Eerste toelating', euro: 'Euroklasse', range: 'Elektrisch bereik', co2: 'CO₂-uitstoot',
      errorPlate: 'Vul een geldig Nederlands kenteken in.', errorNotFound: 'Dit kenteken is niet gevonden bij RDW. Controleer het kenteken of gebruik het artikel met upload.',
      errorIncomplete: 'De RDW-gegevens zijn niet volledig genoeg voor een automatische controle. Gebruik het artikel met upload.',
      errorRate: 'Er zijn momenteel te veel RDW-controles. Probeer het over enkele minuten opnieuw.',
      errorNetwork: 'De RDW-controle kon niet worden uitgevoerd. Probeer het opnieuw of gebruik het artikel met upload.',
      errorConfirm: 'Controleer eerst het kenteken via RDW en bevestig daarna het voertuig.',
      errorQuantity: 'Voeg elk voertuig afzonderlijk toe. De hoeveelheid moet voor deze RDW-bestelling op 1 staan.',
      greenYes: 'Groen mogelijk', greenManual: 'Groen handmatig controleren', greenNo: 'Groen niet mogelijk', blueYes: 'Blauw mogelijk', blueManual: 'Blauw handmatig controleren', blueNo: 'Blauw niet mogelijk',
      fuelElectric: 'Elektrisch', fuelPhev: 'Plug-in hybride', fuelHybrid: 'Hybride', fuelPetrol: 'Benzine', fuelDiesel: 'Diesel', fuelGas: 'Gas', fuelHydrogen: 'Waterstof', fuelUnknown: 'Onbekend',
      typeCar: 'Personenauto', typeVan: 'Bedrijfswagen', typeTruck: 'Vrachtwagen', typeCamper: 'Camper', typeBus: 'Bus', typeMotorcycle: 'Motorfiets', typeUnknown: 'Onbekend'
    },
    en: {
      title: 'Check your Dutch licence plate',
      intro: 'We retrieve the vehicle data automatically from RDW. No registration document upload is required.',
      plateLabel: 'Licence plate', placeholder: 'For example AB-12-CD', lookup: 'Check licence plate', loading: 'Checking RDW…',
      hint: 'One licence plate per order. Add multiple vehicles one at a time.',
      confirm: 'Yes, this is my vehicle and the licence plate is correct.',
      eligibleHeading: 'This vehicle is eligible for the green environmental sticker.', eligibleText: 'Confirm the vehicle. You can then add the sticker to the cart.',
      manualHeading: 'This vehicle needs a manual check.', manualText: 'The available RDW data do not allow a reliable automatic decision. Use the product with registration document upload.',
      noneHeading: 'A green environmental sticker cannot be issued for this vehicle.', noneText: 'According to the available RDW data, the vehicle does not meet the requirements.',
      uploadButton: 'Order with registration document upload', blueText: 'The blue E-sticker is also recommended for this vehicle.', blueLink: 'View the blue E-sticker',
      vehicle: 'Vehicle', vehicleType: 'Vehicle type', fuel: 'Fuel', firstReg: 'First registration', euro: 'Euro class', range: 'Electric range', co2: 'CO₂ emissions',
      errorPlate: 'Enter a valid Dutch licence plate.', errorNotFound: 'This licence plate was not found by RDW. Check it or use the product with document upload.',
      errorIncomplete: 'The RDW data are not complete enough for an automatic check. Use the product with document upload.', errorRate: 'There are currently too many RDW checks. Try again in a few minutes.',
      errorNetwork: 'The RDW check could not be completed. Try again or use the product with document upload.', errorConfirm: 'Check the licence plate through RDW first and then confirm the vehicle.',
      errorQuantity: 'Add each vehicle separately. The quantity for this RDW order must be 1.',
      greenYes: 'Green eligible', greenManual: 'Green requires manual check', greenNo: 'Green not eligible', blueYes: 'Blue eligible', blueManual: 'Blue requires manual check', blueNo: 'Blue not eligible',
      fuelElectric: 'Electric', fuelPhev: 'Plug-in hybrid', fuelHybrid: 'Hybrid', fuelPetrol: 'Petrol', fuelDiesel: 'Diesel', fuelGas: 'Gas', fuelHydrogen: 'Hydrogen', fuelUnknown: 'Unknown',
      typeCar: 'Passenger car', typeVan: 'Van', typeTruck: 'Truck', typeCamper: 'Camper', typeBus: 'Bus', typeMotorcycle: 'Motorcycle', typeUnknown: 'Unknown'
    },
    de: {
      title: 'Niederländisches Kennzeichen prüfen', intro: 'Wir rufen die Fahrzeugdaten automatisch bei RDW ab. Ein Fahrzeugschein-Upload ist nicht erforderlich.',
      plateLabel: 'Kennzeichen', placeholder: 'Zum Beispiel AB-12-CD', lookup: 'Kennzeichen prüfen', loading: 'RDW wird abgefragt…', hint: 'Ein Kennzeichen pro Bestellung. Mehrere Fahrzeuge bitte nacheinander hinzufügen.',
      confirm: 'Ja, das ist mein Fahrzeug und das Kennzeichen ist korrekt.', eligibleHeading: 'Dieses Fahrzeug ist für die grüne Umweltplakette geeignet.', eligibleText: 'Bestätigen Sie das Fahrzeug. Danach können Sie die Plakette in den Warenkorb legen.',
      manualHeading: 'Dieses Fahrzeug muss manuell geprüft werden.', manualText: 'Mit den verfügbaren RDW-Daten ist keine sichere automatische Entscheidung möglich. Verwenden Sie den Artikel mit Fahrzeugschein-Upload.',
      noneHeading: 'Für dieses Fahrzeug kann keine grüne Umweltplakette ausgestellt werden.', noneText: 'Nach den verfügbaren RDW-Daten erfüllt das Fahrzeug die Voraussetzungen nicht.',
      uploadButton: 'Mit Fahrzeugschein-Upload bestellen', blueText: 'Für dieses Fahrzeug wird auch die blaue E-Plakette empfohlen.', blueLink: 'Blaue E-Plakette ansehen',
      vehicle: 'Fahrzeug', vehicleType: 'Fahrzeugart', fuel: 'Antrieb', firstReg: 'Erstzulassung', euro: 'Euroklasse', range: 'Elektrische Reichweite', co2: 'CO₂-Ausstoß',
      errorPlate: 'Geben Sie ein gültiges niederländisches Kennzeichen ein.', errorNotFound: 'Dieses Kennzeichen wurde bei RDW nicht gefunden. Prüfen Sie die Eingabe oder verwenden Sie den Artikel mit Upload.',
      errorIncomplete: 'Die RDW-Daten reichen für eine automatische Prüfung nicht aus. Verwenden Sie den Artikel mit Upload.', errorRate: 'Derzeit gibt es zu viele RDW-Abfragen. Versuchen Sie es in einigen Minuten erneut.',
      errorNetwork: 'Die RDW-Prüfung konnte nicht durchgeführt werden. Versuchen Sie es erneut oder verwenden Sie den Artikel mit Upload.', errorConfirm: 'Prüfen Sie zuerst das Kennzeichen über RDW und bestätigen Sie danach das Fahrzeug.',
      errorQuantity: 'Fügen Sie jedes Fahrzeug einzeln hinzu. Die Menge muss bei dieser RDW-Bestellung 1 sein.',
      greenYes: 'Grün möglich', greenManual: 'Grün manuell prüfen', greenNo: 'Grün nicht möglich', blueYes: 'Blau möglich', blueManual: 'Blau manuell prüfen', blueNo: 'Blau nicht möglich',
      fuelElectric: 'Elektro', fuelPhev: 'Plug-in-Hybrid', fuelHybrid: 'Hybrid', fuelPetrol: 'Benzin', fuelDiesel: 'Diesel', fuelGas: 'Gas', fuelHydrogen: 'Wasserstoff', fuelUnknown: 'Unbekannt',
      typeCar: 'Pkw', typeVan: 'Transporter', typeTruck: 'Lkw', typeCamper: 'Wohnmobil', typeBus: 'Bus', typeMotorcycle: 'Motorrad', typeUnknown: 'Unbekannt'
    },
    fr: {
      title: 'Vérifier votre immatriculation néerlandaise', intro: 'Nous récupérons automatiquement les données du véhicule auprès de RDW. Aucun document d’immatriculation ne doit être téléversé.',
      plateLabel: 'Immatriculation', placeholder: 'Par ex. AB-12-CD', lookup: 'Vérifier l’immatriculation', loading: 'Vérification RDW…', hint: 'Une immatriculation par commande. Ajoutez plusieurs véhicules un par un.',
      confirm: 'Oui, il s’agit de mon véhicule et l’immatriculation est correcte.', eligibleHeading: 'Ce véhicule est éligible à la vignette environnementale verte.', eligibleText: 'Confirmez le véhicule. Vous pourrez ensuite ajouter la vignette au panier.',
      manualHeading: 'Ce véhicule doit être vérifié manuellement.', manualText: 'Les données RDW disponibles ne permettent pas une décision automatique fiable. Utilisez l’article avec téléversement du document.',
      noneHeading: 'Aucune vignette environnementale verte ne peut être délivrée pour ce véhicule.', noneText: 'Selon les données RDW disponibles, le véhicule ne remplit pas les conditions.',
      uploadButton: 'Commander avec téléversement du document', blueText: 'La vignette E bleue est également recommandée pour ce véhicule.', blueLink: 'Voir la vignette E bleue',
      vehicle: 'Véhicule', vehicleType: 'Type de véhicule', fuel: 'Motorisation', firstReg: 'Première immatriculation', euro: 'Classe Euro', range: 'Autonomie électrique', co2: 'Émissions de CO₂',
      errorPlate: 'Saisissez une immatriculation néerlandaise valide.', errorNotFound: 'Cette immatriculation n’a pas été trouvée chez RDW. Vérifiez-la ou utilisez l’article avec téléversement.',
      errorIncomplete: 'Les données RDW ne suffisent pas pour une vérification automatique. Utilisez l’article avec téléversement.', errorRate: 'Trop de vérifications RDW sont en cours. Réessayez dans quelques minutes.',
      errorNetwork: 'La vérification RDW n’a pas pu être effectuée. Réessayez ou utilisez l’article avec téléversement.', errorConfirm: 'Vérifiez d’abord l’immatriculation via RDW, puis confirmez le véhicule.',
      errorQuantity: 'Ajoutez chaque véhicule séparément. La quantité doit être de 1 pour cette commande RDW.',
      greenYes: 'Verte possible', greenManual: 'Verte à vérifier', greenNo: 'Verte non possible', blueYes: 'Bleue possible', blueManual: 'Bleue à vérifier', blueNo: 'Bleue non possible',
      fuelElectric: 'Électrique', fuelPhev: 'Hybride rechargeable', fuelHybrid: 'Hybride', fuelPetrol: 'Essence', fuelDiesel: 'Diesel', fuelGas: 'Gaz', fuelHydrogen: 'Hydrogène', fuelUnknown: 'Inconnu',
      typeCar: 'Voiture particulière', typeVan: 'Utilitaire', typeTruck: 'Camion', typeCamper: 'Camping-car', typeBus: 'Autobus', typeMotorcycle: 'Moto', typeUnknown: 'Inconnu'
    },
    it: {
      title: 'Controlla la targa olandese', intro: 'Recuperiamo automaticamente i dati del veicolo da RDW. Non è necessario caricare il documento di registrazione.',
      plateLabel: 'Targa', placeholder: 'Ad es. AB-12-CD', lookup: 'Controlla la targa', loading: 'Controllo RDW…', hint: 'Una targa per ordine. Aggiungi più veicoli uno alla volta.',
      confirm: 'Sì, questo è il mio veicolo e la targa è corretta.', eligibleHeading: 'Questo veicolo è idoneo al bollino ambientale verde.', eligibleText: 'Conferma il veicolo. Potrai quindi aggiungere il bollino al carrello.',
      manualHeading: 'Questo veicolo deve essere controllato manualmente.', manualText: 'I dati RDW disponibili non consentono una decisione automatica affidabile. Usa l’articolo con caricamento del documento.',
      noneHeading: 'Per questo veicolo non può essere rilasciato un bollino ambientale verde.', noneText: 'Secondo i dati RDW disponibili, il veicolo non soddisfa i requisiti.',
      uploadButton: 'Ordina caricando il documento', blueText: 'Per questo veicolo è consigliato anche il bollino E blu.', blueLink: 'Vedi il bollino E blu',
      vehicle: 'Veicolo', vehicleType: 'Tipo di veicolo', fuel: 'Alimentazione', firstReg: 'Prima immatricolazione', euro: 'Classe Euro', range: 'Autonomia elettrica', co2: 'Emissioni di CO₂',
      errorPlate: 'Inserisci una targa olandese valida.', errorNotFound: 'Questa targa non è stata trovata da RDW. Controllala o usa l’articolo con caricamento.',
      errorIncomplete: 'I dati RDW non sono sufficienti per un controllo automatico. Usa l’articolo con caricamento.', errorRate: 'Al momento ci sono troppe richieste RDW. Riprova tra qualche minuto.',
      errorNetwork: 'Il controllo RDW non è stato completato. Riprova o usa l’articolo con caricamento.', errorConfirm: 'Controlla prima la targa tramite RDW e poi conferma il veicolo.',
      errorQuantity: 'Aggiungi ogni veicolo separatamente. La quantità deve essere 1 per questo ordine RDW.',
      greenYes: 'Verde possibile', greenManual: 'Verde da verificare', greenNo: 'Verde non possibile', blueYes: 'Blu possibile', blueManual: 'Blu da verificare', blueNo: 'Blu non possibile',
      fuelElectric: 'Elettrico', fuelPhev: 'Ibrido plug-in', fuelHybrid: 'Ibrido', fuelPetrol: 'Benzina', fuelDiesel: 'Diesel', fuelGas: 'Gas', fuelHydrogen: 'Idrogeno', fuelUnknown: 'Sconosciuto',
      typeCar: 'Autovettura', typeVan: 'Furgone', typeTruck: 'Camion', typeCamper: 'Camper', typeBus: 'Autobus', typeMotorcycle: 'Motocicletta', typeUnknown: 'Sconosciuto'
    },
    pl: {
      title: 'Sprawdź holenderski numer rejestracyjny', intro: 'Automatycznie pobieramy dane pojazdu z RDW. Przesyłanie dowodu rejestracyjnego nie jest potrzebne.',
      plateLabel: 'Numer rejestracyjny', placeholder: 'Np. AB-12-CD', lookup: 'Sprawdź numer', loading: 'Sprawdzanie RDW…', hint: 'Jeden numer na zamówienie. Kilka pojazdów dodawaj pojedynczo.',
      confirm: 'Tak, to mój pojazd, a numer rejestracyjny jest poprawny.', eligibleHeading: 'Ten pojazd kwalifikuje się do zielonej plakietki ekologicznej.', eligibleText: 'Potwierdź pojazd. Następnie możesz dodać plakietkę do koszyka.',
      manualHeading: 'Ten pojazd wymaga ręcznej kontroli.', manualText: 'Dostępne dane RDW nie pozwalają na wiarygodną automatyczną decyzję. Użyj produktu z przesłaniem dowodu rejestracyjnego.',
      noneHeading: 'Dla tego pojazdu nie można wydać zielonej plakietki ekologicznej.', noneText: 'Według dostępnych danych RDW pojazd nie spełnia wymagań.',
      uploadButton: 'Zamów z przesłaniem dokumentu', blueText: 'Dla tego pojazdu zalecana jest również niebieska plakietka E.', blueLink: 'Zobacz niebieską plakietkę E',
      vehicle: 'Pojazd', vehicleType: 'Rodzaj pojazdu', fuel: 'Napęd', firstReg: 'Pierwsza rejestracja', euro: 'Klasa Euro', range: 'Zasięg elektryczny', co2: 'Emisja CO₂',
      errorPlate: 'Wpisz prawidłowy holenderski numer rejestracyjny.', errorNotFound: 'RDW nie znalazło tego numeru. Sprawdź go lub użyj produktu z przesłaniem dokumentu.',
      errorIncomplete: 'Dane RDW nie wystarczają do automatycznej kontroli. Użyj produktu z przesłaniem dokumentu.', errorRate: 'Obecnie jest zbyt wiele zapytań RDW. Spróbuj ponownie za kilka minut.',
      errorNetwork: 'Nie udało się wykonać kontroli RDW. Spróbuj ponownie lub użyj produktu z przesłaniem dokumentu.', errorConfirm: 'Najpierw sprawdź numer w RDW, a następnie potwierdź pojazd.',
      errorQuantity: 'Dodawaj każdy pojazd osobno. Ilość dla tego zamówienia RDW musi wynosić 1.',
      greenYes: 'Zielona możliwa', greenManual: 'Zielona: kontrola ręczna', greenNo: 'Zielona niemożliwa', blueYes: 'Niebieska możliwa', blueManual: 'Niebieska: kontrola ręczna', blueNo: 'Niebieska niemożliwa',
      fuelElectric: 'Elektryczny', fuelPhev: 'Hybryda plug-in', fuelHybrid: 'Hybryda', fuelPetrol: 'Benzyna', fuelDiesel: 'Diesel', fuelGas: 'Gaz', fuelHydrogen: 'Wodór', fuelUnknown: 'Nieznany',
      typeCar: 'Samochód osobowy', typeVan: 'Samochód dostawczy', typeTruck: 'Ciężarówka', typeCamper: 'Kamper', typeBus: 'Autobus', typeMotorcycle: 'Motocykl', typeUnknown: 'Nieznany'
    },
    cs: {
      title: 'Zkontrolujte nizozemskou registrační značku', intro: 'Údaje vozidla automaticky načteme z RDW. Nahrání technického průkazu není nutné.',
      plateLabel: 'Registrační značka', placeholder: 'Např. AB-12-CD', lookup: 'Zkontrolovat značku', loading: 'Kontrola RDW…', hint: 'Jedna značka na objednávku. Více vozidel přidávejte jednotlivě.',
      confirm: 'Ano, toto je moje vozidlo a registrační značka je správná.', eligibleHeading: 'Toto vozidlo splňuje podmínky pro zelenou ekologickou plaketu.', eligibleText: 'Potvrďte vozidlo. Poté můžete plaketu přidat do košíku.',
      manualHeading: 'Toto vozidlo je nutné zkontrolovat ručně.', manualText: 'Dostupná data RDW neumožňují spolehlivé automatické rozhodnutí. Použijte produkt s nahráním technického průkazu.',
      noneHeading: 'Pro toto vozidlo nelze vydat zelenou ekologickou plaketu.', noneText: 'Podle dostupných dat RDW vozidlo nesplňuje podmínky.',
      uploadButton: 'Objednat s nahráním dokladu', blueText: 'Pro toto vozidlo se doporučuje také modrá E-plaketa.', blueLink: 'Zobrazit modrou E-plaketu',
      vehicle: 'Vozidlo', vehicleType: 'Typ vozidla', fuel: 'Pohon', firstReg: 'První registrace', euro: 'Třída Euro', range: 'Elektrický dojezd', co2: 'Emise CO₂',
      errorPlate: 'Zadejte platnou nizozemskou registrační značku.', errorNotFound: 'RDW tuto značku nenašlo. Zkontrolujte ji nebo použijte produkt s nahráním dokladu.',
      errorIncomplete: 'Data RDW nestačí k automatické kontrole. Použijte produkt s nahráním dokladu.', errorRate: 'Momentálně probíhá příliš mnoho kontrol RDW. Zkuste to za několik minut.',
      errorNetwork: 'Kontrolu RDW se nepodařilo provést. Zkuste to znovu nebo použijte produkt s nahráním dokladu.', errorConfirm: 'Nejprve zkontrolujte značku přes RDW a poté potvrďte vozidlo.',
      errorQuantity: 'Každé vozidlo přidejte samostatně. Množství pro tuto objednávku RDW musí být 1.',
      greenYes: 'Zelená možná', greenManual: 'Zelená: ruční kontrola', greenNo: 'Zelená není možná', blueYes: 'Modrá možná', blueManual: 'Modrá: ruční kontrola', blueNo: 'Modrá není možná',
      fuelElectric: 'Elektrický', fuelPhev: 'Plug-in hybrid', fuelHybrid: 'Hybrid', fuelPetrol: 'Benzín', fuelDiesel: 'Nafta', fuelGas: 'Plyn', fuelHydrogen: 'Vodík', fuelUnknown: 'Neznámý',
      typeCar: 'Osobní automobil', typeVan: 'Dodávka', typeTruck: 'Nákladní automobil', typeCamper: 'Obytný automobil', typeBus: 'Autobus', typeMotorcycle: 'Motocykl', typeUnknown: 'Neznámý'
    },
    da: {
      title: 'Kontrollér din nederlandske nummerplade', intro: 'Vi henter automatisk køretøjsdata fra RDW. Det er ikke nødvendigt at uploade registreringsattesten.',
      plateLabel: 'Nummerplade', placeholder: 'F.eks. AB-12-CD', lookup: 'Kontrollér nummerplade', loading: 'Kontrollerer RDW…', hint: 'Én nummerplade pr. bestilling. Tilføj flere køretøjer ét ad gangen.',
      confirm: 'Ja, dette er mit køretøj, og nummerpladen er korrekt.', eligibleHeading: 'Dette køretøj er berettiget til det grønne miljømærkat.', eligibleText: 'Bekræft køretøjet. Derefter kan du lægge mærkatet i kurven.',
      manualHeading: 'Dette køretøj skal kontrolleres manuelt.', manualText: 'De tilgængelige RDW-data giver ikke mulighed for en sikker automatisk afgørelse. Brug produktet med upload af registreringsattest.',
      noneHeading: 'Der kan ikke udstedes et grønt miljømærkat til dette køretøj.', noneText: 'Ifølge de tilgængelige RDW-data opfylder køretøjet ikke kravene.',
      uploadButton: 'Bestil med dokument-upload', blueText: 'Det blå E-mærkat anbefales også til dette køretøj.', blueLink: 'Se det blå E-mærkat',
      vehicle: 'Køretøj', vehicleType: 'Køretøjstype', fuel: 'Drivmiddel', firstReg: 'Første registrering', euro: 'Euroklasse', range: 'Elektrisk rækkevidde', co2: 'CO₂-udledning',
      errorPlate: 'Indtast en gyldig nederlandsk nummerplade.', errorNotFound: 'RDW fandt ikke denne nummerplade. Kontrollér den, eller brug produktet med dokument-upload.',
      errorIncomplete: 'RDW-data er ikke tilstrækkelige til en automatisk kontrol. Brug produktet med dokument-upload.', errorRate: 'Der er i øjeblikket for mange RDW-kontroller. Prøv igen om nogle minutter.',
      errorNetwork: 'RDW-kontrollen kunne ikke gennemføres. Prøv igen, eller brug produktet med dokument-upload.', errorConfirm: 'Kontrollér først nummerpladen via RDW, og bekræft derefter køretøjet.',
      errorQuantity: 'Tilføj hvert køretøj separat. Antallet skal være 1 for denne RDW-bestilling.',
      greenYes: 'Grønt muligt', greenManual: 'Grønt: manuel kontrol', greenNo: 'Grønt ikke muligt', blueYes: 'Blåt muligt', blueManual: 'Blåt: manuel kontrol', blueNo: 'Blåt ikke muligt',
      fuelElectric: 'Elektrisk', fuelPhev: 'Plug-in-hybrid', fuelHybrid: 'Hybrid', fuelPetrol: 'Benzin', fuelDiesel: 'Diesel', fuelGas: 'Gas', fuelHydrogen: 'Brint', fuelUnknown: 'Ukendt',
      typeCar: 'Personbil', typeVan: 'Varevogn', typeTruck: 'Lastbil', typeCamper: 'Autocamper', typeBus: 'Bus', typeMotorcycle: 'Motorcykel', typeUnknown: 'Ukendt'
    }
  };


  const BLUE_TRANSLATIONS = {
    nl: {
      title: 'Controleer uw Nederlandse kenteken voor de blauwe E-sticker',
      intro: 'Wij halen de voertuiggegevens automatisch op bij RDW en controleren of de blauwe E-sticker automatisch kan worden besteld.',
      eligibleHeading: 'Dit voertuig is geschikt voor de blauwe E-sticker.',
      eligibleText: 'Bevestig het voertuig. Daarna kunt u de blauwe E-sticker aan de winkelwagen toevoegen.',
      manualHeading: 'Dit voertuig moet handmatig worden gecontroleerd voor de blauwe E-sticker.',
      manualText: 'Met de beschikbare RDW-gegevens kan geen veilige automatische beslissing worden genomen. Gebruik de blauwe E-sticker met kentekenbewijs-upload.',
      noneHeading: 'Voor dit voertuig kan geen blauwe E-sticker automatisch worden afgegeven.',
      noneText: 'Volgens de beschikbare RDW-gegevens voldoet het voertuig niet aan de voorwaarden voor de blauwe E-sticker.',
      uploadButton: 'Blauwe E-sticker met kentekenbewijs-upload bestellen'
    },
    en: {
      title: 'Check your Dutch licence plate for the blue E-sticker',
      intro: 'We retrieve the vehicle data automatically from RDW and check whether the blue E-sticker can be ordered automatically.',
      eligibleHeading: 'This vehicle is eligible for the blue E-sticker.',
      eligibleText: 'Confirm the vehicle. You can then add the blue E-sticker to the cart.',
      manualHeading: 'This vehicle needs a manual check for the blue E-sticker.',
      manualText: 'The available RDW data do not allow a reliable automatic decision. Use the blue E-sticker product with registration document upload.',
      noneHeading: 'A blue E-sticker cannot be issued automatically for this vehicle.',
      noneText: 'According to the available RDW data, the vehicle does not meet the requirements for the blue E-sticker.',
      uploadButton: 'Order blue E-sticker with document upload'
    },
    de: {
      title: 'Niederländisches Kennzeichen für die blaue E-Plakette prüfen',
      intro: 'Wir rufen die Fahrzeugdaten automatisch bei RDW ab und prüfen, ob die blaue E-Plakette direkt bestellt werden kann.',
      eligibleHeading: 'Dieses Fahrzeug ist für die blaue E-Plakette geeignet.',
      eligibleText: 'Bestätigen Sie das Fahrzeug. Danach können Sie die blaue E-Plakette in den Warenkorb legen.',
      manualHeading: 'Dieses Fahrzeug muss für die blaue E-Plakette manuell geprüft werden.',
      manualText: 'Mit den verfügbaren RDW-Daten ist keine sichere automatische Entscheidung möglich. Verwenden Sie die blaue E-Plakette mit Fahrzeugschein-Upload.',
      noneHeading: 'Für dieses Fahrzeug kann die blaue E-Plakette nicht automatisch ausgestellt werden.',
      noneText: 'Nach den verfügbaren RDW-Daten erfüllt das Fahrzeug die Voraussetzungen für die blaue E-Plakette nicht.',
      uploadButton: 'Blaue E-Plakette mit Fahrzeugschein-Upload bestellen'
    },
    fr: {
      title: 'Vérifier l’immatriculation néerlandaise pour la vignette E bleue',
      intro: 'Nous récupérons automatiquement les données RDW et vérifions si la vignette E bleue peut être commandée directement.',
      eligibleHeading: 'Ce véhicule est éligible à la vignette E bleue.',
      eligibleText: 'Confirmez le véhicule. Vous pourrez ensuite ajouter la vignette E bleue au panier.',
      manualHeading: 'Ce véhicule doit être vérifié manuellement pour la vignette E bleue.',
      manualText: 'Les données RDW disponibles ne permettent pas une décision automatique fiable. Utilisez le produit avec téléversement du document.',
      noneHeading: 'La vignette E bleue ne peut pas être délivrée automatiquement pour ce véhicule.',
      noneText: 'Selon les données RDW disponibles, le véhicule ne remplit pas les conditions pour la vignette E bleue.',
      uploadButton: 'Commander la vignette E bleue avec document'
    },
    it: {
      title: 'Controlla la targa olandese per il bollino E blu',
      intro: 'Recuperiamo automaticamente i dati RDW e verifichiamo se il bollino E blu può essere ordinato direttamente.',
      eligibleHeading: 'Questo veicolo è idoneo al bollino E blu.',
      eligibleText: 'Conferma il veicolo. Potrai quindi aggiungere il bollino E blu al carrello.',
      manualHeading: 'Questo veicolo richiede un controllo manuale per il bollino E blu.',
      manualText: 'I dati RDW disponibili non consentono una decisione automatica affidabile. Usa il prodotto con caricamento del documento.',
      noneHeading: 'Il bollino E blu non può essere emesso automaticamente per questo veicolo.',
      noneText: 'Secondo i dati RDW disponibili, il veicolo non soddisfa i requisiti per il bollino E blu.',
      uploadButton: 'Ordina il bollino E blu con caricamento documento'
    },
    pl: {
      title: 'Sprawdź holenderski numer dla niebieskiej plakietki E',
      intro: 'Automatycznie pobieramy dane RDW i sprawdzamy, czy niebieską plakietkę E można zamówić bezpośrednio.',
      eligibleHeading: 'Ten pojazd kwalifikuje się do niebieskiej plakietki E.',
      eligibleText: 'Potwierdź pojazd. Następnie możesz dodać niebieską plakietkę E do koszyka.',
      manualHeading: 'Ten pojazd wymaga ręcznej kontroli dla niebieskiej plakietki E.',
      manualText: 'Dostępne dane RDW nie pozwalają na wiarygodną automatyczną decyzję. Użyj produktu z przesłaniem dowodu rejestracyjnego.',
      noneHeading: 'Dla tego pojazdu nie można automatycznie wydać niebieskiej plakietki E.',
      noneText: 'Według dostępnych danych RDW pojazd nie spełnia wymagań dla niebieskiej plakietki E.',
      uploadButton: 'Zamów niebieską plakietkę E z dokumentem'
    },
    cs: {
      title: 'Zkontrolujte nizozemskou značku pro modrou E-plaketu',
      intro: 'Automaticky načteme data RDW a ověříme, zda lze modrou E-plaketu objednat přímo.',
      eligibleHeading: 'Toto vozidlo splňuje podmínky pro modrou E-plaketu.',
      eligibleText: 'Potvrďte vozidlo. Poté můžete modrou E-plaketu přidat do košíku.',
      manualHeading: 'Toto vozidlo je nutné pro modrou E-plaketu zkontrolovat ručně.',
      manualText: 'Dostupná data RDW neumožňují spolehlivé automatické rozhodnutí. Použijte produkt s nahráním dokladu.',
      noneHeading: 'Pro toto vozidlo nelze modrou E-plaketu vydat automaticky.',
      noneText: 'Podle dostupných dat RDW vozidlo nesplňuje podmínky pro modrou E-plaketu.',
      uploadButton: 'Objednat modrou E-plaketu s dokladem'
    },
    da: {
      title: 'Kontrollér den nederlandske nummerplade for det blå E-mærkat',
      intro: 'Vi henter automatisk RDW-data og kontrollerer, om det blå E-mærkat kan bestilles direkte.',
      eligibleHeading: 'Dette køretøj er berettiget til det blå E-mærkat.',
      eligibleText: 'Bekræft køretøjet. Derefter kan du lægge det blå E-mærkat i kurven.',
      manualHeading: 'Dette køretøj skal kontrolleres manuelt for det blå E-mærkat.',
      manualText: 'RDW-dataene giver ikke mulighed for en sikker automatisk afgørelse. Brug produktet med upload af registreringsattesten.',
      noneHeading: 'Det blå E-mærkat kan ikke udstedes automatisk til dette køretøj.',
      noneText: 'Ifølge de tilgængelige RDW-data opfylder køretøjet ikke kravene til det blå E-mærkat.',
      uploadButton: 'Bestil blåt E-mærkat med dokument-upload'
    }
  };

  function normalizeText(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[’'`´]/g, '')
      .replace(/[_\-–—/:]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function sanitizeDisplayPlate(value) {
    return String(value || '')
      .toUpperCase()
      .replace(/[^\p{L}\p{N}\- ]/gu, '')
      .replace(/\s+/g, ' ')
      .slice(0, 16)
      .trim();
  }

  function sanitizePlateTyping(value) {
    return String(value || '')
      .toUpperCase()
      .replace(/[^\p{L}\p{N}\- ]/gu, '')
      .replace(/\s{2,}/g, ' ')
      .replace(/^\s+/, '')
      .slice(0, 16);
  }

  function normalizePlate(value) {
    return sanitizeDisplayPlate(value).replace(/[^A-Z0-9]/g, '');
  }

  function genericPlateLength(value) {
    return sanitizeDisplayPlate(value).replace(/[^\p{L}\p{N}]/gu, '').length;
  }

  function isRdwCompatiblePlate(value) {
    return /^[A-Z0-9 -]+$/.test(sanitizeDisplayPlate(value));
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function findProductForm(root) {
    const id = root.dataset.productFormId || '';
    if (id) {
      const byId = document.getElementById(id);
      if (byId && byId.matches('form')) return byId;
    }

    const section = root.closest('.shopify-section') || root.closest('[id^="MainProduct-"]') || document;
    return section.querySelector('product-form form[action*="/cart/add"], form[action*="/cart/add"]');
  }

  function getScope(root, form) {
    return root.closest('.shopify-section') || form?.closest('.shopify-section') || root.closest('.product') || document;
  }

  function getControlDescriptor(control) {
    const labels = control.labels ? Array.from(control.labels).map((label) => label.textContent || '').join(' ') : '';
    const wrapper = control.closest('.gpo-element, .globo-form-control, [class*="gpo-"], [class*="globo"], .product-form__input, .field');
    const wrapperText = wrapper ? (wrapper.textContent || '').slice(0, 700) : '';
    const nearbyText = [];
    let node = control.parentElement;
    let depth = 0;
    while (node && depth < 4) {
      const text = (node.textContent || '').trim();
      if (text && text.length <= 900) nearbyText.push(text);
      const previousText = (node.previousElementSibling?.textContent || '').trim();
      if (previousText && previousText.length <= 500) nearbyText.push(previousText);
      node = node.parentElement;
      depth += 1;
    }
    return normalizeText([
      control.name,
      control.id,
      control.value,
      control.getAttribute('aria-label'),
      control.getAttribute('placeholder'),
      control.getAttribute('title'),
      control.getAttribute('data-label'),
      control.getAttribute('data-name'),
      labels,
      wrapperText,
      nearbyText.join(' ')
    ].filter(Boolean).join(' '));
  }

  function findExistingPlateInput(scope, root) {
    const explicit = scope.querySelector('.gb-rdw-existing-plate input, input.gb-rdw-existing-plate, [data-gb-rdw-existing-plate]');
    if (explicit && !root.contains(explicit)) return explicit;

    const candidates = Array.from(scope.querySelectorAll('input[type="text"], input:not([type]), textarea'))
      .filter((control) => !root.contains(control));

    let best = null;
    let bestScore = 0;
    candidates.forEach((control) => {
      const descriptor = getControlDescriptor(control);
      let score = 0;
      if (/\bkenteken\b/.test(descriptor)) score += 100;
      if (/licen[cs]e plate|registration plate|number plate/.test(descriptor)) score += 70;
      if (/properties\s*kenteken/.test(descriptor)) score += 40;
      if (normalizeText(control.name).includes('properties')) score += 20;
      if (score > bestScore) {
        best = control;
        bestScore = score;
      }
    });

    return bestScore >= 70 ? best : null;
  }

  function findExistingConfirmInput(scope, root) {
    const explicitWrapper = scope.querySelector('.gb-rdw-existing-confirm');
    if (explicitWrapper && !root.contains(explicitWrapper)) {
      const explicitControl = explicitWrapper.matches('input[type="checkbox"], input[type="radio"]')
        ? explicitWrapper
        : explicitWrapper.querySelector('input[type="checkbox"], input[type="radio"]');
      if (explicitControl) return explicitControl;
    }

    const explicit = scope.querySelector('input.gb-rdw-existing-confirm, [data-gb-rdw-existing-confirm]');
    if (explicit && !root.contains(explicit) && explicit.matches('input[type="checkbox"], input[type="radio"]')) return explicit;

    const candidates = Array.from(scope.querySelectorAll('input[type="checkbox"], input[type="radio"]'))
      .filter((control) => !root.contains(control));

    let best = null;
    let bestScore = 0;
    candidates.forEach((control) => {
      const descriptor = getControlDescriptor(control);
      let score = 0;
      if (/kenteken/.test(descriptor)) score += 60;
      if (/ingevoerde\s+kenteken/.test(descriptor)) score += 70;
      if (/correct|juist|bevestig|confirm/.test(descriptor)) score += 60;
      if (/\b(ok|oke|okay)\b/.test(descriptor)) score += 20;
      if (/properties/.test(normalizeText(control.name))) score += 10;
      if (score > bestScore) {
        best = control;
        bestScore = score;
      }
    });

    return bestScore >= 80 ? best : null;
  }

  function safeWrapper(control) {
    if (!control) return null;
    const wrapper = control.closest('.gpo-element, .globo-form-control, [data-option-id], [class*="gpo-element"], [class*="globo-form"], .product-form__input');
    if (wrapper) return wrapper;

    const field = control.closest('.field');
    if (field && (field.textContent || '').length < 700) return field;

    const parent = control.parentElement;
    if (parent && (parent.textContent || '').length < 500) return parent;
    return null;
  }

  function hideOriginalControl(control) {
    if (!control) return;
    const wrapper = safeWrapper(control);
    if (wrapper) {
      wrapper.classList.add('gb-rdw-product__original-hidden');
      return;
    }
    control.classList.add('gb-rdw-product__original-hidden');
    if (control.labels) Array.from(control.labels).forEach((label) => label.classList.add('gb-rdw-product__original-hidden'));
  }

  function hideOriginalConfirmControl(control, root) {
    if (!control) return;
    let node = control.parentElement;
    let best = null;
    let depth = 0;
    while (node && depth < 5) {
      if (root && node.contains(root)) break;
      const text = normalizeText(node.textContent || '');
      if (text.length <= 1000 && /kenteken/.test(text) && /correct|juist|bevestig|confirm/.test(text)) {
        best = node;
      }
      if (node.classList?.contains('shopify-section')) break;
      node = node.parentElement;
      depth += 1;
    }
    if (best) {
      best.classList.add('gb-rdw-product__original-hidden');
      return;
    }
    hideOriginalControl(control);
  }

  function dispatchControlEvents(control) {
    if (!control) return;
    ['input', 'change'].forEach((type) => control.dispatchEvent(new Event(type, { bubbles: true })));
  }

  function syncCheckableControl(control, checked) {
    if (!control) return;
    const desired = Boolean(checked);
    if (Boolean(control.checked) !== desired) {
      try {
        control.click();
      } catch (error) {}
    }
    if (Boolean(control.checked) !== desired) {
      control.checked = desired;
      dispatchControlEvents(control);
    }
    control.setAttribute('aria-checked', desired ? 'true' : 'false');
  }

  function createOrUpdateProperty(form, key, value) {
    if (!form || !key) return null;
    let input = Array.from(form.querySelectorAll('input[data-gb-rdw-property]'))
      .find((candidate) => candidate.dataset.gbRdwProperty === key) || null;
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = `properties[${key}]`;
      input.dataset.gbRdwProperty = key;
      form.appendChild(input);
    }
    input.value = value || '';
    return input;
  }

  function removeGeneratedProperties(form) {
    if (!form) return;
    form.querySelectorAll('[data-gb-rdw-property]').forEach((input) => input.remove());
  }

  function formatDate(value, locale) {
    if (!value) return '';
    try {
      return new Intl.DateTimeFormat(locale === 'en' ? 'en-GB' : (locale === 'nl' ? 'nl-NL' : locale)).format(new Date(`${value}T00:00:00`));
    } catch (error) {
      return String(value);
    }
  }

  function formatNumber(value, locale) {
    const number = Number(value);
    if (!Number.isFinite(number)) return '';
    try {
      return new Intl.NumberFormat(locale === 'en' ? 'en-GB' : (locale === 'nl' ? 'nl-NL' : locale), { maximumFractionDigits: 1 }).format(number);
    } catch (error) {
      return String(Math.round(number * 10) / 10);
    }
  }

  function fuelLabel(data, t) {
    return t[`fuel${String(data?.fuel_type || 'unknown').replace(/^./, (char) => char.toUpperCase())}`] || t.fuelUnknown;
  }

  function typeLabel(data, t) {
    return t[`type${String(data?.vehicle_type || 'unknown').replace(/^./, (char) => char.toUpperCase())}`] || t.typeUnknown;
  }

  function vehicleName(data) {
    return [data?.make, data?.model].filter(Boolean).join(' ').trim();
  }

  function resultSummary(data, t) {
    const green = data?.green?.status === 'green' ? t.greenYes : (data?.green?.status === 'none' ? t.greenNo : t.greenManual);
    const blue = data?.blue?.status === 'eligible' ? t.blueYes : (data?.blue?.status === 'manual' ? t.blueManual : t.blueNo);
    return `${green} · ${blue}`;
  }

  function rememberBlueEligibility(plate, data) {
    if (data?.blue?.status !== 'eligible') return;
    try {
      window.sessionStorage.setItem(BLUE_FLAG_KEY, '1');
      const raw = window.sessionStorage.getItem(BLUE_ELIGIBLE_PLATES_KEY);
      const parsed = raw ? JSON.parse(raw) : [];
      const values = Array.isArray(parsed) ? parsed : [];
      const identity = normalizePlate(plate);
      const filtered = values.filter((value) => normalizePlate(value) !== identity);
      filtered.push(plate);
      window.sessionStorage.setItem(BLUE_ELIGIBLE_PLATES_KEY, JSON.stringify(filtered.slice(-12)));
    } catch (error) {}
  }

  function initRoot(root) {
    if (!root || root.dataset.gbRdwInitialized === '1') return;
    root.dataset.gbRdwInitialized = '1';

    const requestedLocale = String(root.dataset.locale || 'nl').toLowerCase().split('-')[0];
    const locale = Object.prototype.hasOwnProperty.call(TRANSLATIONS, requestedLocale) ? requestedLocale : 'nl';
    const mode = root.dataset.productMode === 'blue' ? 'blue' : 'green';
    const t = mode === 'blue'
      ? Object.assign({}, TRANSLATIONS[locale], BLUE_TRANSLATIONS[locale] || BLUE_TRANSLATIONS.nl)
      : TRANSLATIONS[locale];
    const apiUrl = String(root.dataset.rdwApiUrl || '').trim();
    const uploadUrl = String(root.dataset.uploadProductUrl || '').trim();
    const blueUrl = String(root.dataset.blueProductUrl || '').trim();
    root.classList.toggle('gb-rdw-product--blue', mode === 'blue');

    const title = root.querySelector('[data-gb-rdw-title]');
    const intro = root.querySelector('[data-gb-rdw-intro]');
    const label = root.querySelector('[data-gb-rdw-plate-label]');
    const plateInput = root.querySelector('[data-gb-rdw-plate]');
    const lookupButton = root.querySelector('[data-gb-rdw-lookup]');
    const hint = root.querySelector('[data-gb-rdw-hint]');
    const errorBox = root.querySelector('[data-gb-rdw-error]');
    const submitError = root.querySelector('[data-gb-rdw-submit-error]');
    const resultBox = root.querySelector('[data-gb-rdw-result]');
    const statusBox = root.querySelector('[data-gb-rdw-status]');
    const resultHeading = root.querySelector('[data-gb-rdw-result-heading]');
    const resultText = root.querySelector('[data-gb-rdw-result-text]');
    const facts = root.querySelector('[data-gb-rdw-facts]');
    const confirmWrap = root.querySelector('[data-gb-rdw-confirm-wrap]');
    const confirmInput = root.querySelector('[data-gb-rdw-confirm]');
    const confirmLabel = root.querySelector('[data-gb-rdw-confirm-label]');
    const uploadLink = root.querySelector('[data-gb-rdw-upload-link]');
    const blueNote = root.querySelector('[data-gb-rdw-blue-note]');
    const blueText = root.querySelector('[data-gb-rdw-blue-text]');
    const blueLink = root.querySelector('[data-gb-rdw-blue-link]');

    if (!plateInput || !lookupButton) return;

    if (title) title.textContent = t.title;
    if (intro) intro.textContent = t.intro;
    if (label) label.textContent = t.plateLabel;
    plateInput.placeholder = t.placeholder;
    lookupButton.textContent = t.lookup;
    if (hint) hint.textContent = t.hint;
    if (confirmLabel) confirmLabel.textContent = t.confirm;
    if (uploadLink) {
      uploadLink.textContent = t.uploadButton;
      if (uploadUrl) uploadLink.href = uploadUrl;
    }
    if (blueText) blueText.textContent = t.blueText;
    if (blueLink) {
      blueLink.textContent = t.blueLink;
      if (blueUrl) blueLink.href = blueUrl;
    }

    let form = findProductForm(root);
    let scope = getScope(root, form);
    let originalPlateInput = null;
    let originalConfirmInput = null;
    let verifiedData = null;
    let verifiedDisplayPlate = '';
    let observer = null;

    function refreshBindings() {
      form = form && document.contains(form) ? form : findProductForm(root);
      scope = getScope(root, form);

      const foundPlate = findExistingPlateInput(scope, root);
      if (foundPlate && foundPlate !== originalPlateInput) {
        originalPlateInput = foundPlate;
        hideOriginalControl(originalPlateInput);
        if (form) {
          Array.from(form.querySelectorAll('input[data-gb-rdw-property]'))
            .filter((input) => input.dataset.gbRdwProperty === 'Kenteken')
            .forEach((input) => input.remove());
        }
        if (verifiedDisplayPlate) {
          originalPlateInput.value = verifiedDisplayPlate;
          dispatchControlEvents(originalPlateInput);
        }
      }

      const foundConfirm = findExistingConfirmInput(scope, root);
      if (foundConfirm && foundConfirm !== originalConfirmInput) {
        originalConfirmInput = foundConfirm;
        hideOriginalConfirmControl(originalConfirmInput, root);
        syncCheckableControl(originalConfirmInput, Boolean(confirmInput?.checked));
      }
    }

    function purchaseButtons() {
      if (!scope) return [];
      return Array.from(scope.querySelectorAll(
        'button[name="add"], product-form button[type="submit"], .gpo-clone-atc-button, [data-add-to-cart]'
      )).filter((button) => !root.contains(button));
    }

    function paymentButtons() {
      if (!scope) return [];
      return Array.from(scope.querySelectorAll('.shopify-payment-button, [data-shopify="payment-button"]'))
        .filter((element) => !root.contains(element));
    }


    let previewInitialized = false;
    let previewFrame = null;
    let previewTextNode = null;

    function previewPlateValue(value) {
      const raw = sanitizeDisplayPlate(String(value || '').split(',')[0]);
      return raw.slice(0, 12).trim();
    }

    function findPreviewHost() {
      const candidates = [
        scope?.querySelector('.product__media-item.is-active .product-media-container'),
        scope?.querySelector('.product__media-item:not(.is-hidden) .product-media-container'),
        scope?.querySelector('.product-media-container'),
        scope?.querySelector('.product__media-item.is-active'),
        scope?.querySelector('.product__media-item:not(.is-hidden)'),
        scope?.querySelector('.product__media'),
        document.querySelector('.product__media-item.is-active .product-media-container'),
        document.querySelector('.product__media-item:not(.is-hidden) .product-media-container'),
        document.querySelector('.product-media-container')
      ];
      return candidates.find(Boolean) || null;
    }

    function ensurePreview() {
      if (previewInitialized && previewFrame && previewTextNode && document.contains(previewFrame)) return true;
      const host = findPreviewHost();
      if (!host) return false;

      host.classList.add('gb-rdw-product__preview-host');
      previewFrame = host.querySelector('[data-gb-rdw-preview]');
      if (!previewFrame) {
        previewFrame = document.createElement('div');
        previewFrame.className = 'gb-rdw-product__plate-preview';
        previewFrame.setAttribute('data-gb-rdw-preview', '');
        previewFrame.setAttribute('aria-hidden', 'true');

        previewTextNode = document.createElement('span');
        previewTextNode.className = 'gb-rdw-product__plate-preview-text';
        previewFrame.appendChild(previewTextNode);
        host.appendChild(previewFrame);
      } else {
        previewTextNode = previewFrame.querySelector('.gb-rdw-product__plate-preview-text') || previewFrame;
      }

      // The preview lives inside the product-media area, outside the RDW form root.
      // Therefore the blue mode must be attached directly to the preview element.
      previewFrame.classList.toggle('gb-rdw-product__plate-preview--blue', mode === 'blue');

      previewInitialized = true;
      return Boolean(previewFrame && previewTextNode);
    }


    function previewPlaceholderText() {
      const placeholders = {
        nl: 'JOUW KENTEKEN',
        en: 'YOUR PLATE',
        de: 'IHR KENNZEICHEN',
        fr: 'VOTRE PLAQUE',
        it: 'LA TUA TARGA',
        pl: 'TWOJA TABLICA',
        cs: 'VAŠE SPZ',
        da: 'DIN NUMMERPLADE'
      };
      return placeholders[locale] || placeholders.nl;
    }

    function updatePreview(value) {
      const previewValue = previewPlateValue(value);
      if (!ensurePreview()) return;

      const hasValue = Boolean(previewValue);
      previewTextNode.textContent = hasValue ? previewValue : previewPlaceholderText();
      previewFrame.classList.add('is-visible');
      previewFrame.classList.toggle('is-placeholder', !hasValue);
      previewFrame.classList.remove('is-medium', 'is-small');

      if (hasValue && previewValue.length >= 12) {
        previewFrame.classList.add('is-small');
      }
    }

    function quantityValue() {
      if (!scope) return 1;
      const input = scope.querySelector('quantity-input input[name="quantity"], input[name="quantity"]');
      const value = Number(input?.value || 1);
      return Number.isFinite(value) ? value : 1;
    }

    function targetEligible(data) {
      return mode === 'blue' ? data?.blue?.status === 'eligible' : data?.green?.status === 'green';
    }

    function targetStatus(data) {
      return mode === 'blue' ? (data?.blue?.status || 'manual') : (data?.green?.status || 'manual');
    }

    function canPurchase() {
      return Boolean(verifiedData && targetEligible(verifiedData) && confirmInput?.checked);
    }

    function setPurchaseAvailability() {
      const allowed = canPurchase();
      purchaseButtons().forEach((button) => {
        if (!allowed) {
          if (!button.disabled) button.dataset.gbRdwDisabled = '1';
          button.disabled = true;
          button.setAttribute('aria-disabled', 'true');
        } else if (button.dataset.gbRdwDisabled === '1') {
          button.disabled = false;
          button.removeAttribute('aria-disabled');
          delete button.dataset.gbRdwDisabled;
        }
      });

      paymentButtons().forEach((element) => {
        element.classList.toggle('gb-rdw-product__payment-hidden', !allowed);
      });
    }

    function showError(message, target) {
      const box = target || errorBox;
      if (!box) return;
      box.textContent = message || t.errorNetwork;
      box.hidden = false;
    }

    function clearError(target) {
      const box = target || errorBox;
      if (!box) return;
      box.textContent = '';
      box.hidden = true;
    }

    function setHidden(element, hidden) {
      if (!element) return;
      element.hidden = Boolean(hidden);
      element.classList.toggle('gb-rdw-product__force-hidden', Boolean(hidden));
    }

    function showManualFallback(message) {
      verifiedData = null;
      verifiedDisplayPlate = '';
      if (resultBox) resultBox.hidden = false;
      if (statusBox) {
        statusBox.classList.remove('is-error');
        statusBox.classList.add('is-warning');
      }
      if (resultHeading) resultHeading.textContent = t.manualHeading;
      if (resultText) resultText.textContent = message || t.manualText;
      if (facts) facts.innerHTML = '';
      if (confirmInput) confirmInput.checked = false;
      setHidden(confirmWrap, true);
      setHidden(blueNote, true);
      setHidden(uploadLink, false);
      if (originalConfirmInput) syncCheckableControl(originalConfirmInput, false);
      removeGeneratedProperties(form);
      setPurchaseAvailability();
    }

    function syncOriginalFields() {
      refreshBindings();
      if (originalPlateInput) {
        originalPlateInput.value = verifiedDisplayPlate;
        dispatchControlEvents(originalPlateInput);
      } else if (form) {
        createOrUpdateProperty(form, 'Kenteken', verifiedDisplayPlate);
      }

      if (originalConfirmInput) {
        syncCheckableControl(originalConfirmInput, Boolean(confirmInput?.checked));
      }
    }

    function writeProperties() {
      if (!form || !verifiedData || !verifiedDisplayPlate) return;
      syncOriginalFields();
      const name = vehicleName(verifiedData);
      const summaryParts = [name, fuelLabel(verifiedData, t), formatDate(verifiedData.first_registration, locale)].filter(Boolean);
      createOrUpdateProperty(form, 'RDW voertuig', summaryParts.join(' · '));
      if (verifiedData.euro_class) createOrUpdateProperty(form, 'RDW Euroklasse', verifiedData.euro_class);
      createOrUpdateProperty(form, 'RDW resultaat', resultSummary(verifiedData, t));
    }

    function resetVerification() {
      verifiedData = null;
      verifiedDisplayPlate = '';
      if (confirmInput) confirmInput.checked = false;
      setHidden(confirmWrap, true);
      if (resultBox) resultBox.hidden = true;
      setHidden(blueNote, true);
      setHidden(uploadLink, true);
      clearError();
      clearError(submitError);
      removeGeneratedProperties(form);
      if (originalPlateInput) {
        originalPlateInput.value = '';
        dispatchControlEvents(originalPlateInput);
      }
      if (originalConfirmInput) {
        syncCheckableControl(originalConfirmInput, false);
      }
      setPurchaseAvailability();
    }

    function resetForNextVehicle() {
      resetVerification();
      plateInput.value = '';
      updatePreview('');

      const quantityInput = scope?.querySelector('quantity-input input[name="quantity"], input[name="quantity"]');
      if (quantityInput && String(quantityInput.value || '') !== '1') {
        quantityInput.value = '1';
        dispatchControlEvents(quantityInput);
      }

      window.setTimeout(() => {
        if (document.contains(plateInput)) plateInput.focus({ preventScroll: true });
      }, 120);
    }

    function bindContinueShoppingReset() {
      if (root.dataset.gbRdwContinueResetBound === '1') return;
      root.dataset.gbRdwContinueResetBound = '1';

      document.addEventListener('click', (event) => {
        const continueButton = event.target.closest(
          'cart-notification .cart-notification__links > button[type="button"].link.button-label'
        );
        if (!continueButton || !canPurchase()) return;

        // Dawn closes the cart notification on the same click. Reset immediately
        // afterwards so the next vehicle starts with an empty RDW form.
        window.setTimeout(resetForNextVehicle, 0);
      }, true);
    }

    function renderFacts(data) {
      if (!facts) return;
      const rows = [];
      const name = vehicleName(data);
      if (name) rows.push([t.vehicle, name]);
      rows.push([t.vehicleType, typeLabel(data, t)]);
      rows.push([t.fuel, fuelLabel(data, t)]);
      if (data.first_registration) rows.push([t.firstReg, formatDate(data.first_registration, locale)]);
      if (data.euro_class) rows.push([t.euro, data.euro_class]);
      if (data.electric_range_km != null && data.fuel_type === 'phev') rows.push([t.range, `${formatNumber(data.electric_range_km, locale)} km`]);
      if (data.co2_g_km != null && data.fuel_type === 'phev') rows.push([t.co2, `${formatNumber(data.co2_g_km, locale)} g/km`]);
      facts.innerHTML = rows.map(([key, value]) => `<dt>${escapeHtml(key)}</dt><dd>${escapeHtml(value)}</dd>`).join('');
    }

    function renderResult(data) {
      if (!resultBox || !statusBox || !resultHeading || !resultText) return;
      resultBox.hidden = false;
      statusBox.classList.remove('is-warning', 'is-error');
      renderFacts(data);

      const status = targetStatus(data);
      const eligible = mode === 'blue' ? status === 'eligible' : status === 'green';
      if (eligible) {
        resultHeading.textContent = t.eligibleHeading;
        resultText.textContent = t.eligibleText;
        setHidden(confirmWrap, false);
        setHidden(uploadLink, true);
      } else if (status === 'none') {
        statusBox.classList.add('is-error');
        resultHeading.textContent = t.noneHeading;
        resultText.textContent = t.noneText;
        setHidden(confirmWrap, true);
        setHidden(uploadLink, true);
      } else {
        statusBox.classList.add('is-warning');
        resultHeading.textContent = t.manualHeading;
        resultText.textContent = t.manualText;
        setHidden(confirmWrap, true);
        setHidden(uploadLink, false);
      }

      setHidden(blueNote, mode === 'blue' || data?.blue?.status !== 'eligible');
      setPurchaseAvailability();
    }

    async function lookupVehicle() {
      const displayPlate = sanitizeDisplayPlate(plateInput.value);
      const normalized = normalizePlate(displayPlate);
      const enteredLength = genericPlateLength(displayPlate);
      plateInput.value = displayPlate;
      updatePreview(displayPlate);
      clearError();
      clearError(submitError);

      if (enteredLength < 2 || enteredLength > 14) {
        showError(t.errorPlate);
        plateInput.focus();
        return;
      }

      // RDW only contains Dutch licence plates (ASCII letters/numbers).
      // Keep international characters such as Ä, Ö, Ü, Å, Ø, Č, Ł etc.
      // visible and usable, but route those entries directly to the manual
      // upload product instead of stripping characters and querying RDW.
      if (!isRdwCompatiblePlate(displayPlate) || normalized.length < 4 || normalized.length > 12) {
        resetVerification();
        plateInput.value = displayPlate;
        updatePreview(displayPlate);
        showError(t.errorNotFound);
        showManualFallback();
        return;
      }
      if (!apiUrl) {
        showError(t.errorNetwork);
        return;
      }

      resetVerification();
      lookupButton.disabled = true;
      lookupButton.classList.add('is-loading');
      const originalText = lookupButton.textContent;
      lookupButton.textContent = t.loading;

      try {
        const response = await fetch(apiUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ plate: normalized, language: locale })
        });
        const payload = await response.json().catch(() => null);
        if (!response.ok || !payload?.ok || !payload?.vehicle) {
          const code = payload?.error?.code || '';
          const message = code === 'NOT_FOUND' || response.status === 404
            ? t.errorNotFound
            : (code === 'INCOMPLETE' ? t.errorIncomplete : (code === 'RATE_LIMIT' || response.status === 429 ? t.errorRate : t.errorNetwork));
          throw Object.assign(new Error(message), { userMessage: message });
        }

        verifiedData = payload.vehicle;
        verifiedDisplayPlate = displayPlate;
        updatePreview(displayPlate);
        renderResult(verifiedData);
        if (targetEligible(verifiedData)) {
          syncOriginalFields();
        }
      } catch (error) {
        const message = error.userMessage || t.errorNetwork;
        showError(message);
        showManualFallback();
      } finally {
        lookupButton.disabled = false;
        lookupButton.classList.remove('is-loading');
        lookupButton.textContent = originalText || t.lookup;
      }
    }

    function syncPreviewFromTyping() {
      const cleaned = sanitizePlateTyping(plateInput.value);
      if (plateInput.value !== cleaned) plateInput.value = cleaned;
      if (verifiedData || confirmInput?.checked) resetVerification();
      updatePreview(cleaned);
    }

    plateInput.addEventListener('input', syncPreviewFromTyping);
    plateInput.addEventListener('keyup', syncPreviewFromTyping);
    plateInput.addEventListener('change', syncPreviewFromTyping);
    plateInput.addEventListener('paste', () => window.setTimeout(syncPreviewFromTyping, 0));

    plateInput.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter') return;
      event.preventDefault();
      lookupVehicle();
    });

    lookupButton.addEventListener('click', lookupVehicle);

    if (confirmInput) {
      confirmInput.addEventListener('change', () => {
        clearError(submitError);
        if (!verifiedData || !targetEligible(verifiedData)) {
          confirmInput.checked = false;
          showError(t.errorConfirm, submitError);
          setPurchaseAvailability();
          return;
        }
        syncOriginalFields();
        if (confirmInput.checked) {
          writeProperties();
          rememberBlueEligibility(verifiedDisplayPlate, verifiedData);
        } else {
          removeGeneratedProperties(form);
        }
        setPurchaseAvailability();
      });
    }

    function validatePurchase(event) {
      if (canPurchase() && quantityValue() === 1) {
        writeProperties();
        rememberBlueEligibility(verifiedDisplayPlate, verifiedData);
        clearError(submitError);
        return true;
      }

      if (event) {
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
      }

      showError(quantityValue() !== 1 ? t.errorQuantity : t.errorConfirm, submitError);
      root.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return false;
    }

    function bindFormGuards() {
      refreshBindings();
      if (form && form.dataset.gbRdwGuarded !== '1') {
        form.dataset.gbRdwGuarded = '1';
        form.addEventListener('submit', validatePurchase, true);
      }

      if (scope && scope.dataset && scope.dataset.gbRdwClickGuarded !== '1') {
        scope.dataset.gbRdwClickGuarded = '1';
        scope.addEventListener('click', (event) => {
          const button = event.target.closest('button[name="add"], product-form button[type="submit"], .gpo-clone-atc-button, [data-add-to-cart]');
          if (!button || root.contains(button)) return;
          validatePurchase(event);
        }, true);
      }
    }

    refreshBindings();
    bindFormGuards();
    bindContinueShoppingReset();
    updatePreview(plateInput.value);
    setPurchaseAvailability();

    observer = new MutationObserver(() => {
      refreshBindings();
      bindFormGuards();
      setPurchaseAvailability();
    });
    observer.observe(scope === document ? document.documentElement : scope, { childList: true, subtree: true });

    window.setTimeout(() => {
      if (observer) observer.disconnect();
      refreshBindings();
      bindFormGuards();
      setPurchaseAvailability();
    }, 15000);
  }

  function initAll() {
    document.querySelectorAll('[data-gb-rdw-product]').forEach(initRoot);
  }

  if (!window[GLOBAL_KEY]) {
    window[GLOBAL_KEY] = true;
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }
  } else {
    initAll();
  }
})();
